import { list } from './list';

export const groups = {
  list,
};
